// extracted by mini-css-extract-plugin
module.exports = {"child":"styles_child__5jeTJ","split":"styles_split__1r53t","item":"styles_item__t9Chy"};